import React from 'react';
import { connect } from 'react-redux';
import Grid from './Grid';

import { remove } from '../actions/general-actions';

import styles from '../../../../stylesheet/css/header-builder/main-area.css';

const MainArea = ({
  onRemove
}) => {
  const onKeyUp = e => {
    if (e.which === 8) {
      onRemove();
    }
  };

  return (
    <div
      tabIndex="-1"
      className={styles.mainArea}
      onKeyUp={onKeyUp}
    >
      <Grid device="desktop" />
      <Grid device="tablet" />
      <Grid device="mobile" />

    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRemove() {
      dispatch(remove());
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(MainArea);



// WEBPACK FOOTER //
// ./app/header-builder/components/MainArea.js